import { styled } from "@mui/material/styles";

const StyledSignup = styled("div")(
  ({ theme }) => `

.signup-wrap {
  width: 40%;
  margin: 0 auto;
  padding: 30px 0;

  @media screen and (max-width: 1025px) {
    width: 80%;
  }

  @media screen and (max-width: 480px) {
    width: 80%;
  }
}
.signup-header {
  font-family: Lexend;
  color: ${theme.palette.primary.main};
  font-weight: 400;
  font-size: 32px;
  font-style: normal;
  line-height: normal;
  @media screen and (max-width: 1025px) {
    font-size: 28px;
  }
  @media screen and (max-width: 480px) {
    font-size: 24px;
  }  
}
.signup-sub-header{
  margin-top: 12px;
  margin-bottom: 32px;
  font-family: Lexend;
  color: ${theme.palette.customColor.secondarySecond};
  font-weight: 300;
  font-size: 16px;
  font-style: normal;
  line-height: 24px;
}
.signup-textfeilds {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.signup-store {
  display: flex;
  gap: 20px;
  @media screen and (max-width: 480px) {
    flex-direction: column;
  }  
}  
.signup-email {
  display: flex;
  gap: 20px;
  @media screen and (max-width: 480px) {
    flex-direction: column;
  }
}  

.terms-condition{
  font-weight: 400;
  font-size: 12px;
  font-style: normal;
  line-height: 15px;
}

.login {
  width: 100%;
  text-align: center;
  margin-top: 15px;
  font-weight: 400;
  font-size: 16px;
  font-style: normal;
  line-height: 20px;
  color: ${theme.palette.customColor.secondarySecond};
  span {
    color: ${theme.palette.primary.main};
    text-decoration: underline;
    margin-left: 3px;
    }
    @media screen and (max-width: 480px) {
      font-size: 14px;
    }  
  }
.terms-condition span {
    color: ${theme.palette.secondary.main};
    cursor: pointer;
    text-decoration: underline;
} 
.text-feilds {
  width: 100%;
}     
.text-feilds-2 {
  width: 48.6%;
   @media screen and (max-width: 480px) {
    width: 100%;
  }
}     
.step-header {
  font-family: lexend;
  font-weight: 400;
  font-size: 20px;
  font-style: normal;
  line-height: 25px;
  color: ${theme.palette.primary.main};
  margin: 20px 0px;
}
.haveAccount {
  margin-top: 20px;
  text-align: center;
  font-family: lexend;
  font-weight: 400;
  font-size: 16px;
  font-style: normal;
  line-height: 20px;
  color: ${theme.palette.customColor.secondarySecond};

}
.haveAccount a {
  font-family: lexend;
  font-weight: 400;
  font-size: 16px;
  font-style: normal;
  line-height: 20px;
  color: ${theme.palette.primary.main};
  text-decoration: underline;
}
.step-sub-header {
  font-family: lexend;
  font-weight: 400;
  font-size: 16px;
  font-style: normal;
  line-height: 20px;
  color: ${theme.palette.primary.main};
  margin-bottom: 10px;
}
.goBack {
  text-align: center;
  margin-top: 20px;
}
.goBack a {
  font-family: lexend;
  font-weight: 400;
  font-size: 16px;
  font-style: normal;
  line-height: 20px;
  text-decorection: underline;
  color: ${theme.palette.primary.main};
}
.submit-btn {
  width: 100%;
  padding: 10px;
  margin-top: 36px;
  font-size: 16px;
  font-weight: 400;
  text-transform: none;
}              
`
);

export default StyledSignup;
